/**
 * PDP details column bottom-pin (client QA 2026-08-14).
 *
 * On products whose media column scrolls far longer than the details column
 * (many gallery images, short copy), the details used to scroll away and
 * leave the right half of the viewport empty. The fix makes the details
 * column sticky with `top: 100dvh - <column height>`: it scrolls naturally,
 * pins the moment its bottom edge reaches the viewport bottom, and releases
 * at the end of the grid row. Short columns pin below the header instead
 * (the `min()` in the CSS formula).
 *
 * CSS in snippets/plw-pdp.liquid owns the formula, gated on the
 * `data-plw-sticky-details` attribute this module stamps — with JS off the
 * column keeps Horizon's stretched layout. This module only measures the
 * column into `--plw-details-h` (ResizeObserver: images, fonts, accordions
 * and variant morphs all change the height) and re-stamps after
 * `variant:update` (the section morph can strip the attribute + inline var,
 * same as the glossary overlay's aria re-apply).
 */

const SELECTOR =
  '.product-information__grid.product-information--media-left .product-details';

const observer = new ResizeObserver((entries) => {
  for (const entry of entries) measure(entry.target);
});

/**
 * @param {Element} details - The details column.
 */
function measure(details) {
  if (!(details instanceof HTMLElement)) return;
  const height = Math.round(details.getBoundingClientRect().height);
  details.style.setProperty('--plw-details-h', `${height}px`);
}

function hydrate() {
  const details = document.querySelector(SELECTOR);
  if (!(details instanceof HTMLElement)) return;
  details.dataset.plwStickyDetails = '';
  measure(details);
  // Re-observing an already-observed element is a no-op.
  observer.observe(details);
}

hydrate();
document.addEventListener('variant:update', () => queueMicrotask(hydrate));
